export default __webpack_public_path__ + "static/media/Viet_Banner_3.99c839c6.webp";